import { CService } from "./class.base.service";

class ProfileService extends CService{
  getTypes<T>(){
    return this.api.get<any,T>('profiles/types');
  }
}

const profileService = new ProfileService("profiles")
export default profileService;